export { default } from "./textAreaWidget";
